import { render, staticRenderFns } from "./Poll.vue?vue&type=template&id=cd4d0ce2&scoped=true&"
import script from "./Poll.vue?vue&type=script&lang=js&"
export * from "./Poll.vue?vue&type=script&lang=js&"
import style0 from "./Poll.vue?vue&type=style&index=0&id=cd4d0ce2&scoped=true&lang=scss&"
import style1 from "./Poll.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4d0ce2",
  null
  
)

export default component.exports